import { EnterHook } from "react-router";
import { useSessionStore } from "../storez/SessionStore";
import { useDevicePermissionsStore } from "../storez/DevicePermissionsStore";

export const UnknownRouteHandler: EnterHook = (_nextState, replace, callback) => {
  if (!useSessionStore.getState().device) {
    replace({ pathname: "/devices" });
    if (callback) callback();
  } else {
    void useDevicePermissionsStore
      .getState()
      .getOrFetch()
      .then(
        () => {
          replace({ pathname: useDevicePermissionsStore.getState().getLandingPage() });
        },
        () => {
          replace({ pathname: "/devices" });
        }
      )
      .finally(() => {
        if (callback) callback();
      });
  }
};
